import { routerStyxie } from '@/router/styxieBridge'
import { useGeogridsCommonStore } from '@/stores/geogrids/common'

Styxie.Initializers.ScheduledGeogridsTagsStatistics = routerStyxie({
  actions: ['index'],
  hydrate: (props, pinia) => useGeogridsCommonStore(pinia).initialize(props)
})
